// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b5b06068","75":"d3e9169c","592":"910e3021","615":"e4a0fd66","734":"cdffe760","754":"44a0ddee","816":"896ef1b6","842":"962e2e47","877":"2c6176f6","892":"6bc8413b"}[chunkId] + ".chunk.js";
};